import {
  array,
  number,
  object,
  string,
  null as zNull,
  type infer as zInfer,
} from "zod/v4";

export const setMintsoftIntegration = {
  name: "setMintsoftIntegration" as const,
  input: object({
    apiKey: string().optional(),
    username: string().optional(),
    password: string().optional(),
    clientId: number(),
    returnReasonMap: array(
      object({
        redoReason: string(),
        mintsoftReasonId: number(),
        mintsoftReasonName: string(),
      }),
    ),
    defaultReturnReasonId: number(),
    defaultReturnReasonName: string(),
  }),
  output: zNull(),
};

export type SetMintsoftIntegrationInput = zInfer<
  typeof setMintsoftIntegration.input
>;
